"use client";

import { useNavigate } from "react-router-dom";
import { formatBillingDate } from "../../../utils/billingFormat";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const ExpiryNudgeModal = ({ isOpen, onClose, endDate, isTrial = false }) => {
  const navigate = useNavigate();

  const handleRenewNow = () => {
    onClose();
    navigate("/dashboard/billing");
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-sm text-center p-6 sm:p-7">
        <div className="flex flex-col items-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-500/10 mb-3">
            <span className="text-3xl">⏰</span>
          </div>
          <DialogHeader className="space-y-1 text-center sm:text-center">
            <DialogTitle className="text-lg font-bold text-gray-900">
              Your {isTrial ? "trial" : "plan"} has expired
            </DialogTitle>
          </DialogHeader>
          <p className="text-xs text-gray-500 mt-2 leading-relaxed">
            It expired on {endDate ? formatBillingDate(endDate) : "recently"}. You can keep using the app during the grace period, but renewing keeps things worry-free.
          </p>
        </div>

        <DialogFooter className="flex flex-col-reverse sm:flex-row sm:justify-center gap-2 mt-4 sm:space-x-0">
          <Button type="button" variant="outline" className="w-full sm:w-auto" onClick={onClose}>
            Remind me later
          </Button>
          <Button type="button" className="w-full sm:w-auto" onClick={handleRenewNow}>
            Renew Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExpiryNudgeModal;
